import loadingLogo from 'assets/images/loading.gif';
import { useAppSelector } from 'hooks';
import { selectFullLoading } from 'state';
import './FullLoader.scss';

export const FullLoader = () => {
  const isLoading = useAppSelector(selectFullLoading);

  return isLoading ? (
    <div className="FullLoader">
      <img src={loadingLogo} alt="loading-logo" className="Loader" />
    </div>
  ) : null;
};
